import { Component, OnChanges, SimpleChanges } from '@angular/core';
import { FacilitiesService } from '../../core/facilities/facilities.service';
import { AbstractSummedAggregateSummaryComponent } from './abstract-summed-aggregate-summary.component';

/**
 * Base class for Pharmacy Summary Chart widgets.
 */
@Component({
    template: '',
    host: {
        'class' : 'abstract-summed-aggregate-summary-charts'
      }
  })
export abstract class AbstractSummedAggregateSummaryChartsComponent extends AbstractSummedAggregateSummaryComponent implements OnChanges {
    // Can't do @Input inheritance, so provide this in the child class's @Component({inputs}) to get the same effect.
    protected static INPUTS: string[] = ['dateRange'];

    /** Construct */
    constructor(facilitiesSvc: FacilitiesService) {
        super(facilitiesSvc);
    }

    /**
     * Respond when the input (dateRange) changes.
     */
    ngOnChanges(charges: SimpleChanges) {
        this.updateIfReady();
    }

    /**
     * Drives the lifecycle of:
     * 1. Clear existing content.
     * 2. Fetch data from backend.
     * 3. Populate the charts with data.
     * 4. Redraw/animate the charts.
     *
     * Automatically called whenever the facility or date range selections change.
     * @override
     */
    protected updateIfReady() {
        if (this.isReadyToUpdate()) {
            this.stop$.next(0);

            // (Re)build all charts in prep for new data, and show loading animation.
            this.destroyAllCharts();
            this.buildAllCharts();
            this.charts.forEach(c => c.showLoading());

            // Fetch data -> populate charts with data -> refresh the display
            this.fetchAndPopulate();
        }
    }
}
